import { REFI_MFE_UUID, RefiBusinessInsights } from '@cof/refi-web-sdk';
import { DebugService } from '../../../shared/services/debug.service.js';
import { REFI_VEHICLE_LOAN_CONST } from '../../../shared/constants/app.constants.js';

class _SessionService {
  constructor() {
    this.debug = new DebugService('SessionService');
    this._businessInsights = new RefiBusinessInsights();
    this.sessionStorageKey =
      REFI_VEHICLE_LOAN_CONST.SESSION_KEY.REFI_SESSION_KEY;
    this._session = JSON.parse(sessionStorage.getItem(this.sessionStorageKey));
    this._pfci =
      sessionStorage.getItem(REFI_VEHICLE_LOAN_CONST.SESSION_KEY.PI_KEY) ===
      '1';
    this.prequalInfoStorageKey =
      REFI_VEHICLE_LOAN_CONST.SESSION_KEY.PREQUAL_INFO_KEY;
    this.vehicleConsentKey =
      REFI_VEHICLE_LOAN_CONST.SESSION_KEY.VEHICLE_CONSENT_KEY;
    this.usedManualLoanStorageKey =
      REFI_VEHICLE_LOAN_CONST.SESSION_KEY.USED_MANUAL_LOAN_KEY;
    this.manualLoanStorageKey =
      REFI_VEHICLE_LOAN_CONST.SESSION_KEY.MANUAL_LOAN_KEY;
    this.selectedLoanStorageKey =
      REFI_VEHICLE_LOAN_CONST.SESSION_KEY.SELECTED_LOAN_KEY;
    this.upfrontOffersStorageKey =
      REFI_VEHICLE_LOAN_CONST.SESSION_KEY.UPFRONT_OFFERS_KEY;
    this.licensePlateStateCodeKey =
      REFI_VEHICLE_LOAN_CONST.SESSION_KEY.LICENSE_PLATE_STATE_CODE_KEY;
  }

  get session() {
    this._session = JSON.parse(sessionStorage.getItem(this.sessionStorageKey));
    this.debug.log('getting session', this._session);
    return this._session;
  }

  getKey(sessionKey) {
    return sessionStorage.getItem(sessionKey);
  }

  getPromotion() {
    return this.getCachedOffer();
  }

  getCachedOffer() {
    const promoStageKey = REFI_VEHICLE_LOAN_CONST.PROMO_STORAGE_KEY;
    const offerString = localStorage.getItem(promoStageKey);

    if (!offerString) {
      return null;
    }
    let offer = JSON.parse(offerString);
    if (!offer.expirationDate) {
      return null;
    }
    if (!this.isOfferStillValid(new Date(offer.expirationDate))) {
      offer = null;
      this.removeCachedOffer();
      this.debug.log('offer expired');
    }
    return offer;
  }

  isOfferStillValid(expirationDate) {
    const currentdate = new Date();
    if (!expirationDate || expirationDate < currentdate) {
      return false;
    }
    return true;
  }

  removeCachedOffer() {
    this.debug.log('removing access code offer');
    localStorage.removeItem(REFI_VEHICLE_LOAN_CONST.PROMO_STORAGE_KEY);
    sessionStorage.removeItem(REFI_VEHICLE_LOAN_CONST.PROMO_STORAGE_KEY);
  }

  get pfci() {
    this.debug.log('getting pfci', this._pfci);
    return this._pfci;
  }

  setReferrerId() {
    this._session.referrerId = REFI_MFE_UUID.REFI_APPLY;
    sessionStorage.setItem(
      this.sessionStorageKey,
      JSON.stringify(this._session)
    );
  }

  removeSession() {
    this.debug.log('removeSession');
    sessionStorage.removeItem(this.sessionStorageKey);
  }

  getPrequalInfo() {
    return JSON.parse(sessionStorage.getItem(this.prequalInfoStorageKey));
  }

  setPrequalInfo(prequalInfo) {
    this.debug.log('setPrequalInfo with', prequalInfo);
    sessionStorage.setItem(
      this.prequalInfoStorageKey,
      JSON.stringify(prequalInfo)
    );
  }

  getVehicleConsent() {
    return JSON.parse(sessionStorage.getItem(this.vehicleConsentKey));
  }

  setVehicleConsent(value) {
    sessionStorage.setItem(this.vehicleConsentKey, JSON.stringify(value));
  }

  removeVehicleConsent() {
    sessionStorage.removeItem(this.vehicleConsentKey);
  }

  setUsedManualLoan(usedManualLoan) {
    sessionStorage.setItem(
      this.usedManualLoanStorageKey,
      JSON.stringify(usedManualLoan)
    );
  }

  getManualLoan() {
    return JSON.parse(sessionStorage.getItem(this.manualLoanStorageKey));
  }

  setManualLoan(loan) {
    sessionStorage.setItem(this.manualLoanStorageKey, JSON.stringify(loan));
  }

  getSelectedLoan() {
    return JSON.parse(sessionStorage.getItem(this.selectedLoanStorageKey));
  }

  setSelectedLoan(loan) {
    sessionStorage.setItem(this.selectedLoanStorageKey, JSON.stringify(loan));
  }

  getUpfrontOffer() {
    return JSON.parse(sessionStorage.getItem(this.upfrontOffersStorageKey));
  }

  getLicensePlateStateCode() {
    return JSON.parse(sessionStorage.getItem(this.licensePlateStateCodeKey));
  }

  setLicensePlateStateCode(licensePlateStateCode) {
    sessionStorage.setItem(
      this.licensePlateStateCodeKey,
      JSON.stringify(licensePlateStateCode)
    );
  }
}

export const SessionService = new _SessionService();
